// This function allow to reference chunks
__webpack_require__.k = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "chunk." + {"757": "cd4757f9589d784a","796": "5cb1c8f2b1235aa7",}[chunkId] + ".css"
}